import { Column, Columns } from '@codeparva/ui-components-library';
import React, { useState } from 'react';
import { HeroTypes } from '..';
import { LocationTypes } from '../../../../..';
import { Row } from '../../../../../components/row/Row';
import { FacilityDetails } from '../components/FacilityDetails';
import { Gallery } from '../components/Gallery';
import { Map } from '../components/Map';
import { SectionHeader } from '../components/SectionHeader';

export const HeroSection1 = ({
  sectionHeader,
  photos,
  locationDetails,
}: HeroTypes.ILocationHero) => {
  const [
    updatedLocationDetails,
    setUpdatedLocationDetails,
  ] = useState<LocationTypes.ILocationMap>(locationDetails);
  return (
    <div className="heroSection1container">
      <Row className="sectionHeaderRowContainer">
        <SectionHeader {...sectionHeader} />
      </Row>
      <Row className="mapGalleryContainerRow">
        <Columns multiline={false} className="mapGalleryColumns is-cp-w-100">
          <Column className="mapColumn is-hidden-mobile" size={5}>
            <Map
              {...updatedLocationDetails}
              onLocationsUpdated={setUpdatedLocationDetails}
            />
          </Column>
          <Column className="galleryColumn" size={7}>
            <Gallery photos={photos} />
          </Column>
        </Columns>
      </Row>
      <Row className="facilityDetailsRow">
        <FacilityDetails location={updatedLocationDetails} />
      </Row>
      <Row className="mapGalleryContainerRow is-hidden-tablet">
        <Columns multiline={false} className="mapGalleryColumns is-cp-w-100">
          <Column className="mapColumn">
            <Map {...locationDetails} />
          </Column>
        </Columns>
      </Row>
    </div>
  );
};
